/**
 * en-GB messages added by Phase 4 task W33 (docs/PHASE-4-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const w33EnGB = {
    'platformUsers.title': "Customer's users",
    'platformUsers.description': 'People who can sign in to this customer’s portal.',
    'platformUsers.email': 'Email',
    'platformUsers.role': 'Role',
    'platformUsers.lastSignIn': 'Last sign-in',
    'platformUsers.never': 'Never',
    'platformUsers.locked': 'Locked',
    'platformUsers.empty': 'This customer has no users yet.',
    'platformUsers.resendInvite': 'Resend invitation',
    'platformUsers.resendInviteFor': 'Resend invitation to {name}',
    'platformUsers.passwordReset': 'Send password reset',
    'platformUsers.passwordResetFor': 'Send password reset to {name}',
    'platformUsers.inviteSent': 'Invitation sent to {email}.',
    'platformUsers.resetSent': 'Password reset email sent to {email}.',
};
//# sourceMappingURL=w33.js.map